import React from 'react';

export const WixDesignSystemContext = React.createContext<{
  newBrandingClass?: string;
  mobile?: boolean;
  contextClassName?: string;
}>({
  newBrandingClass: 'no-brand',
  mobile: false,
  contextClassName: '',
});
